<app-site-widget #widget
	[title]="titlePlc"
	[tooltipText]="tooltipText"
	[elementId]="elementId"
	chartType="progress"
	[hideTable]="true"
	[hideDevs]="true"
	[titleStyle]="true"
	[tagStyle]="true"
	[widgetClass]="widgetClass"
	[siteWidgetOptions]="siteWidgetOptions"
	[widgetOptions]="{noExpand: true,hasExport: true}"
	(eventEmit)="eventEmit($event)"
	[data]="data"
	[config]="config"
	[tableColumns]="tableColumns"
	[siteId]="siteId"
	[customerId]="customerId"
	[customerName]="customerName"
	[siteName]="siteName"
	chartContainerStyle="plc-extra-padding"
></app-site-widget>

